import { fetchURL, fetchJSON, removePrefix } from './utils';

import moment from 'moment';

export async function getInboxInfo(inboxLink) {
  console.log('Getting inbox link info: ' + inboxLink);
  let action = await ibb.getInboxInfo(inboxLink);
  if (action.error.type) {
    throw new Error('Error getting inbox link info: ' + action.error.type);
  }

  return action.node;
}

export async function getHash(hash) {

  console.log('Getting link info: ' + hash);
  let action = await ibb.getLinkInfo(hash);
  if (action.error.type) {
    throw new Error('Error getting link info: ' + action.error.type);
  }

  let re = /(?:\.([^.]+))?$/;
  let extension = re.exec(action.node.name)[1] || '';
  extension = extension.toLowerCase();

  let type = '';
  if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'bmp' || extension == 'heic' || extension == 'heif') {
    type = 'image';
  }   
  else if (extension == 'mp3' || extension == 'wav' || extension == 'flac') {
    type = 'audio';
  }
  else if (extension == 'avi' || extension == 'mp4' || extension == 'mkv') {
    type = 'video';
  }
  else if (extension == 'pdf') {
    type = 'pdf';
  }
  else if (extension == 'stl') {
      type = 'stl';
  }
  else if (extension == 'zip') {
    type = 'zip';
}

  let ctime = action.node.ctime || (moment().valueOf() / 1000);
  let response = '{"path":"/' + action.node.name + '",'
              + '"name":"' + action.node.name + '",'
              + '"size":' + action.node.size + ','
              + '"extension":"' + extension + '",'
              + '"modified":"' + moment(ctime * 1000).format() + '",'
              + '"mode":420,"isDir":false,"type":"' + type + '",'
              + '"metadataInfo":"' + action.node.metadataInfo + '"}';

  console.log('Response: ' + response);
  return JSON.parse(response); 

  //return fetchJSON(`/api/public/share/${hash}`)
}

export async function getFolderLink(link) {

  console.log('Getting folder link info: ' + link);
  let action = await ibbLink.loginLink(link);
  if (action.error.type) {
    throw new Error('Error logging to folder link: ' + action.error.type);
  }

  action = await ibbLink.getNodes();
  if (action.error.type) {
    throw new Error('Error getting nodes from folder link: ' + action.error.type);
  }

  const ctime = action.node.ctime || (moment().valueOf() / 1000);
  return {
    handle: action.node.handle,
    path: `/${action.node.name}`,
    name: action.node.name,
    size: action.node.size,
    modified: moment(ctime * 1000).format(),
    mode: 420,
    isDir: true,
    type: 'folder',
    metadataInfo: action.node.metadataInfo,
  };
}

export async function getId(handle) {
  console.log('Creating link for handle: ' + handle);
  let action = await ibb.createLink(handle);

  let response = '[{"hash":"' + action.text 
  + '","link":"' + action.link 
  + '","name":"' + action.node.name
  + '","expire":0}]'; 

  return JSON.parse(response);
}

export async function get(url) {
  url = removePrefix(url);
  let path = decodeURIComponent(url);

  console.log('Creating link for path: ' + path);

  let action = await ibb.getNodeByPath(path);
  if (action.error.type) {
    throw new Error('Error getting node by path: ' + action.error.type);
  }

  action = await ibb.createLink(action.node.handle);

  let response = '[{"hash":"' + action.text 
  + '","link":"' + action.link 
  + '","path":"' + path 
  + '","userID":2,"expire":0}]'; 

  return JSON.parse(response);

  //return fetchJSON(`/api/share${url}`)
}

export async function remove(hash) {
  const res = await fetchURL(`/api/share/${hash}`, {
    method: 'DELETE'
  });

  if (res.status !== 200) {
    throw new Error(res.status);
  }
}

export async function create(url, expires = '', unit = 'hours') {
  url = removePrefix(url);
  url = `/api/share${url}`;
  if (expires !== '') {
    url += `?expires=${expires}&unit=${unit}`;
  }

  return fetchJSON(url, {
    method: 'POST'
  });
}
